import React from 'react';
import Button from '../Button';
import style from './style.module.css';

export default function ConfirmationButton({
  confirmText,
  rejectText,
  confirmFunction,
  rejectFunction,
}) {
  return (
    <div className={`${style.container}`}>
      {confirmText && (
        <Button onClick={confirmFunction} className={`secondBtn`}>
          {confirmText}
        </Button>
      )}
      {rejectText && (
        <Button onClick={rejectFunction} className={`sendBtn`}>
          {rejectText}
        </Button>
      )}
    </div>
  );
}
